import React from 'react';
import ResourcifiCard from './components/ResourcifiCard';
import './App.css';

function App() {
  return (
    <div className="App">
      <ResourcifiCard />
    </div>
  );
}

export default App;